//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ShearsDivider',
}
